import { PaneArea } from '../../../types/shared'
import Measure, { IMeasureAttrs } from '../../canvas/measure'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IMeasureAttrs
type PartialAttrs = Partial<Attrs>

class MeasureCreator extends Measure<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const width = this.model.scale.x.width(80)
    const height = this.model.scale.y.height(35)
    this.attrs.x1 = Math.round(startArea.x - width)
    this.attrs.x2 = Math.round(startArea.x + width)
    this.attrs.y1 = startArea.y + height
    this.attrs.y2 = startArea.y - height

    setTimeout(() => {
      this.replaceMyself(Measure.fromObject<Measure>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default MeasureCreator
